import {Button} from 'antd'
import {useMapContext} from '@/components/MindMap/index.mjs'
import {MarkdownViewer} from '@/components/Markdown'
import {Alert, useOpenModal} from '@/components/Modal'

export default function PropertiesPaneButtonViewImpact(props) {
    const openModal = useOpenModal()
    const map = useMapContext()
    const selectedNodes = map.useSelectedNodes()

    if (1 !== selectedNodes.size) {
        return null
    }

    const [node] = [...selectedNodes]
    const {impactReport} = node.data

    if (! impactReport) {
        return null
    }

    const onClick = () => openModal(
        <Alert
            title="变更影响分析报告"
            width={800}
        >
            <MarkdownViewer>
                {impactReport}
            </MarkdownViewer>
        </Alert>
    )

    return (
        <Button
            onClick={onClick}
            {...props}
        >
            查看变更影响分析报告
        </Button>
    )
}
